import { Button, DropdownItem, HFlow, Icon, Tooltip } from 'bold-ui'
import { useAlert } from 'components/alert'
import { DropdownButton } from 'components/dropdown'
import { confirm } from 'components/modals/confirm'
import React from 'react'
import { isUndefinedOrNull } from 'util/checks'
import { OBSERVACAO_DISABLE_REMOVE_TOOLTIP_TEXT } from 'view/atendimentos/atendimento-individual/atendimento-observacao/model-atendObservacao'
import { VisualizarDiscussaoCuidadoCompartilhadoAction } from 'view/atendimentos/detail/historico/components/accordion/header/components/VisualizarDiscussaoCuidadoCompartilhadoAction'

import { TipoCompartilhamentoCuidadoPlanoEnum } from '../../cuidado-compartilhado/model-cuidadocompartilhado'
import { CompartilhamentoCuidadoPlanoModel } from '../model-compartilhamentocuidado'

interface CompartilhamentoCuidadoTableActionsProps {
  row: CompartilhamentoCuidadoPlanoModel
  viaFolhaRosto: boolean
  hasEditingRecordId: boolean
  onEdit?: (id: ID) => void
  onDelete?: (id: ID) => void
  onImprimir?: (row: CompartilhamentoCuidadoPlanoModel) => void
}

export const CompartilhamentoCuidadoTableActions = (props: CompartilhamentoCuidadoTableActionsProps) => {
  const { row, viaFolhaRosto, hasEditingRecordId, onEdit, onDelete, onImprimir } = props

  const alert = useAlert()

  const handleDelete = (id: ID) =>
    confirm({
      title: `Deseja excluir ${
        row.tipo === TipoCompartilhamentoCuidadoPlanoEnum.GUIA_ENCAMINHAMENTO
          ? 'a guia de encaminhamento'
          : 'o cuidado compartilhado'
      }?`,
      type: 'danger',
      confirmLabel: 'Excluir',

      onConfirm: () => {
        onDelete(id)
        alert(
          'success',
          `${
            row.tipo === TipoCompartilhamentoCuidadoPlanoEnum.GUIA_ENCAMINHAMENTO
              ? 'Guia de encaminhamento excluída'
              : 'Cuidado compartilhado excluído'
          } com sucesso.`
        )
      },
    })()

  const onClickEdit = (e: React.MouseEvent) => {
    e.stopPropagation()
    return onEdit(row.cacheId)
  }

  const onClickDelete = (e: React.MouseEvent) => {
    e.stopPropagation()
    return handleDelete(row.cacheId)
  }

  const onClickImprimir = (e: React.MouseEvent) => {
    e.stopPropagation()
    return onImprimir(row)
  }

  const tooltipEditDisabled = hasEditingRecordId
    ? 'Não é possível editar registros de encaminhamento em rascunho dentro de um atendimento de observação.'
    : ''

  const tooltipExcludeDisabled = hasEditingRecordId ? OBSERVACAO_DISABLE_REMOVE_TOOLTIP_TEXT : ''

  return row.isRegistradoAgora
    ? (onEdit || onDelete) && (
        <HFlow alignItems='center' justifyContent='flex-end' hSpacing={0.5}>
          {row.tipo === TipoCompartilhamentoCuidadoPlanoEnum.GUIA_ENCAMINHAMENTO && (
            <Tooltip text='Imprimir'>
              <Button size='small' skin='ghost' onClick={onClickImprimir}>
                <Icon icon='printerOutline' />
              </Button>
            </Tooltip>
          )}
          <Tooltip text='Mais opções'>
            <DropdownButton stopPropagationOnClick>
              {onEdit && (
                <Tooltip text={tooltipEditDisabled}>
                  <DropdownItem type='normal' onClick={onClickEdit} disabled={hasEditingRecordId}>
                    Editar
                  </DropdownItem>
                </Tooltip>
              )}

              {onDelete && (
                <Tooltip text={tooltipExcludeDisabled} placement='bottom'>
                  <DropdownItem type='danger' onClick={onClickDelete} disabled={hasEditingRecordId}>
                    <HFlow alignItems='center' hSpacing={0.5}>
                      <Icon icon='trashOutline' />
                      Excluir
                    </HFlow>
                  </DropdownItem>
                </Tooltip>
              )}
            </DropdownButton>
          </Tooltip>
        </HFlow>
      )
    : !isUndefinedOrNull(row.dbId) && (
        <HFlow alignItems='center' justifyContent='flex-end' hSpacing={0.5}>
          {row.tipo === TipoCompartilhamentoCuidadoPlanoEnum.CUIDADO_COMPARTILHADO ? (
            <VisualizarDiscussaoCuidadoCompartilhadoAction
              cuidadoCompartilhadoId={row.dbId}
              viaFolhaRosto={viaFolhaRosto}
            />
          ) : (
            <Tooltip text='Imprimir'>
              <Button size='small' skin='ghost' onClick={onClickImprimir}>
                <Icon icon='printerOutline' />
              </Button>
            </Tooltip>
          )}
        </HFlow>
      )
}
